import { useEffect, useRef, useState } from "react";
import { motion, useInView, animate } from "framer-motion";
import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const DEFAULTS = [
  { key: "immobili", value: 57, label: "Immobili gestiti", testid: "stat-immobili-gestiti" },
  { key: "contratti", value: 102, label: "Contratti di affitto gestiti", testid: "stat-contratti-gestiti" },
  { key: "proprietari", value: 56, label: "Proprietari che hanno scelto Semplificaffitto.it", testid: "stat-proprietari" },
];

function Counter({ to, testid }) {
  const ref = useRef(null);
  const inView = useInView(ref, { once: true, margin: "-40px" });
  const [val, setVal] = useState(0);

  useEffect(() => {
    if (!inView) return;
    const controls = animate(0, to, {
      duration: 2,
      ease: [0.16, 1, 0.3, 1],
      onUpdate: (v) => setVal(Math.round(v)),
    });
    return () => controls.stop();
  }, [inView, to]);

  return (
    <span ref={ref} data-testid={testid} className="font-serif font-bold text-6xl lg:text-7xl text-brandblue tabular-nums leading-none">
      {val}
    </span>
  );
}

export default function Stats() {
  const [stats, setStats] = useState(DEFAULTS);

  useEffect(() => {
    axios
      .get(`${API}/settings/stats`)
      .then(({ data }) => {
        setStats(DEFAULTS.map((d) => ({ ...d, value: data[d.key] ?? d.value })));
      })
      .catch(() => {});
  }, []);

  return (
    <section data-testid="stats-section" className="bg-white border-y border-ink/10 py-16 lg:py-20">
      <div className="max-w-7xl mx-auto px-5 lg:px-8">
        <div className="grid grid-cols-2 sm:grid-cols-3 gap-8 sm:gap-6">
          {stats.map((s, i) => (
            <motion.div
              key={s.testid}
              initial={{ opacity: 0, y: 24 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-40px" }}
              transition={{ duration: 0.6, delay: i * 0.12 }}
              className="text-center sm:text-left sm:border-l sm:border-ink/10 sm:pl-8 first:border-0 first:pl-0"
              data-testid={`${s.testid}-card`}
            >
              <Counter to={s.value} testid={s.testid} />
              <p className="mt-3 text-sm lg:text-base text-ink/55 leading-snug max-w-[240px] mx-auto sm:mx-0">{s.label}</p>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}
